/**
 * Spanish (es) mappings for Welcome Message
 */

export const welcomeMessageES = {
  // Welcome message text
  "Welcome to PickStar AI - Your Personalized Sports Research Assistant. Ask away!":
    "Bienvenido a PickStar AI - Tu Asistente de Investigación Deportiva Personalizado. ¡Pregunta lo que quieras!"
};
